import { render, staticRenderFns } from "./CreditParameter.vue?vue&type=template&id=2e3821b8&scoped=true&"
import script from "./CreditParameter.vue?vue&type=script&lang=js&"
export * from "./CreditParameter.vue?vue&type=script&lang=js&"
import style0 from "./CreditParameter.vue?vue&type=style&index=0&id=2e3821b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3821b8",
  null
  
)

export default component.exports